export const ProjectType = {
	Game: 'Game',
	Code: 'Code',
}
